var _templateObject;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
// @ts-nocheck
import { gql, useMutation, useQuery } from "@apollo/client";
import { useState, useEffect } from 'react';
import { upperFirst } from 'lodash';
import { notification } from 'antd';
import castAttributesFromModel from "../ModelDefinition/castAttributesFromDefinition";
var showNotification = function showNotification(flash) {
  notification[flash.type || 'open']({
    message: flash.message,
    description: null,
    placement: 'bottomRight',
    duration: 2
  });
};
var handleNotifications = function handleNotifications(response) {
  var data = response.data;
  if (data) {
    var queryKeys = Object.keys(data);
    queryKeys.forEach(function (key) {
      var _data$key;
      (((_data$key = data[key]) === null || _data$key === void 0 ? void 0 : _data$key.flashMessages) || []).forEach(function (flashMessage) {
        showNotification(JSON.parse(flashMessage));
      });
    });
  }
  return response;
};
var generateMutation = function generateMutation(modelName, actionName, fragment, options) {
  var _fragment$definitions, _fragment$definitions2;
  var fragmentName = fragment ? (_fragment$definitions = fragment.definitions.find(function (d) {
    return d.kind === "FragmentDefinition" && d.name.kind === "Name";
  })) === null || _fragment$definitions === void 0 ? void 0 : (_fragment$definitions2 = _fragment$definitions.name) === null || _fragment$definitions2 === void 0 ? void 0 : _fragment$definitions2.value : undefined;
  var inName = (options === null || options === void 0 ? void 0 : options.inputName) || "".concat(upperFirst(actionName)).concat(upperFirst(modelName), "Input");
  return gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ", "($input: ", "!) {\n      ", "(input: $input) {\n        ", " {\n          ...", "\n        }\n        ", "\n      }\n    }\n    ", "\n  "])), options.mutationName, inName, options.mutationName, modelName, fragmentName, options.flashMessages ? 'flashMessages' : '', fragment);
};
function useGraphqlModel(modelName, opts) {
  var _opts$flashMessages = opts.flashMessages,
    flashMessages = _opts$flashMessages === void 0 ? false : _opts$flashMessages,
    definition = opts.definition,
    _opts$queries = opts.queries,
    _opts$queries2 = _opts$queries === void 0 ? {} : _opts$queries,
    fetchQuery = _opts$queries2.fetch,
    _opts$defaultMutation = opts.defaultMutationNames,
    defaultMutationNames = _opts$defaultMutation === void 0 ? {} : _opts$defaultMutation,
    _opts$defaultInputNam = opts.defaultInputNames,
    defaultInputNames = _opts$defaultInputNam === void 0 ? {} : _opts$defaultInputNam,
    _opts$mutations = opts.mutations,
    mutations = _opts$mutations === void 0 ? {} : _opts$mutations,
    fragment = opts.fragment;
  var createMutation = mutations.create;
  var createMutationName = defaultMutationNames.create || "create".concat(upperFirst(modelName));
  if (!createMutation && fragment) {
    var createInputName;
    if (defaultInputNames) {
      if (typeof defaultInputNames === 'function') {
        createInputName = defaultInputNames('create', modelName);
      } else if (defaultInputNames.create) {
        createInputName = defaultInputNames.create;
      }
    }
    createMutation = generateMutation(modelName, 'create', fragment, {
      inputName: createInputName,
      flashMessages: flashMessages,
      mutationName: createMutationName
    });
  }
  var updateMutation = mutations.update;
  var updateMutationName = defaultMutationNames.update || "update".concat(upperFirst(modelName));
  if (!updateMutation && fragment) {
    var updateInputName;
    if (defaultInputNames) {
      if (typeof defaultInputNames === 'function') {
        updateInputName = defaultInputNames('update', modelName);
      } else if (defaultInputNames.update) {
        updateInputName = defaultInputNames.update;
      }
    }
    updateMutation = generateMutation(modelName, 'update', fragment, {
      inputName: updateInputName,
      flashMessages: flashMessages,
      mutationName: updateMutationName
    });
  }
  var deleteMutation = mutations.delete;
  var deleteMutationName = defaultMutationNames.delete || "delete".concat(upperFirst(modelName));
  if (!deleteMutation && fragment) {
    var deleteInputName;
    if (defaultInputNames) {
      if (typeof defaultInputNames === 'function') {
        deleteInputName = defaultInputNames('delete', modelName);
      } else if (defaultInputNames.delete) {
        deleteInputName = defaultInputNames.delete;
      }
    }
    deleteMutation = generateMutation(modelName, 'delete', fragment, {
      inputName: deleteInputName,
      flashMessages: flashMessages,
      mutationName: deleteMutationName
    });
  }
  var importMutation = mutations.import;
  var importMutationName = defaultMutationNames.import || "import".concat(upperFirst(modelName), "s");
  if (!importMutation && fragment) {
    var importInputName;
    if (defaultInputNames) {
      if (typeof defaultInputNames === 'function') {
        importInputName = defaultInputNames('import', modelName);
      } else if (defaultInputNames.delete) {
        importInputName = defaultInputNames.import;
      }
    }
    importMutation = generateMutation(modelName, 'import', fragment, {
      inputName: importInputName,
      flashMessages: flashMessages,
      mutationName: importMutationName
    });
  }
  return function (id, options) {
    var _ref = options || {},
      _ref$mutationOptions = _ref.mutationOptions,
      mutationOptions = _ref$mutationOptions === void 0 ? {} : _ref$mutationOptions,
      _ref$fetch = _ref.fetch,
      fetch = _ref$fetch === void 0 ? false : _ref$fetch,
      _ref$singleton = _ref.singleton,
      singleton = _ref$singleton === void 0 ? false : _ref$singleton,
      queries = _ref.queries;
    var hasUpload = definition && (Object.values(definition).includes('File') || Object.values(definition).includes('Files'));
    var onError = function onError(error) {
      return console.log(error);
    };
    var _ref2 = fetchQuery || queries !== null && queries !== void 0 && queries.fetch ? useQuery(
      // @ts-ignore
      (queries === null || queries === void 0 ? void 0 : queries.fetch) || fetchQuery, _objectSpread({
        variables: {
          id: id
        },
        skip: !fetch || !id && !singleton || !fetchQuery,
        fetchPolicy: 'cache-and-network',
        onError: onError
      }, _typeof(fetch) === "object" ? fetch : {})) : {},
      _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? {} : _ref2$data,
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? false : _ref2$loading,
      _ref2$refetch = _ref2.refetch,
      refetch = _ref2$refetch === void 0 ? undefined : _ref2$refetch;
    var record = data[modelName] || {};
    var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];
    useEffect(function () {
      setErrors(undefined);
    }, [id]);

    // @ts-ignore
    var _ref3 = createMutation ? useMutation(createMutation, _objectSpread(_objectSpread({}, mutationOptions || {}), {}, {
        context: {
          hasUpload: hasUpload
        }
      })) : [],
      _ref4 = _slicedToArray(_ref3, 2),
      create = _ref4[0],
      creating = _ref4[1].loading;

    // @ts-ignore
    var _ref5 = updateMutation ? useMutation(updateMutation, _objectSpread(_objectSpread({}, mutationOptions || {}), {}, {
        context: {
          hasUpload: hasUpload
        }
      })) : [],
      _ref6 = _slicedToArray(_ref5, 2),
      update = _ref6[0],
      updating = _ref6[1].loading;
    var _ref7 = deleteMutation ? useMutation(deleteMutation, _objectSpread({}, mutationOptions || {})) : [],
      _ref8 = _slicedToArray(_ref7, 1),
      destroy = _ref8[0];
    var _ref9 = importMutation ? useMutation(importMutation, _objectSpread({}, mutationOptions || {})) : [],
      _ref10 = _slicedToArray(_ref9, 1),
      importMutationDispatcher = _ref10[0];
    var onSave = function onSave(payload, options) {
      // @ts-ignore
      var attributes = definition || options !== null && options !== void 0 && options.definition ? castAttributesFromModel((options === null || options === void 0 ? void 0 : options.definition) || definition, payload) : payload;
      if (opts.debug) console.log("attributes", attributes);
      var onCompleted = function onCompleted(data) {
        var recordErrors = data.recordErrors;
        if (flashMessages) handleNotifications(data);
        if (recordErrors) setErrors(recordErrors);else setErrors(undefined);
        if (options !== null && options !== void 0 && options.onCompleted) options.onCompleted(data);
      };
      if (id || options !== null && options !== void 0 && options.id || singleton) {
        if (update) update({
          variables: {
            input: _objectSpread({
              id: id || (options === null || options === void 0 ? void 0 : options.id),
              attributes: attributes
            }, (options === null || options === void 0 ? void 0 : options.variables) || {})
          },
          onCompleted: onCompleted
        });
      } else {
        if (create) create({
          variables: {
            input: _objectSpread({
              attributes: attributes
            }, (options === null || options === void 0 ? void 0 : options.variables) || {})
          },
          onCompleted: onCompleted
        });
      }
    };
    var onDelete = function onDelete(id, options) {
      if (opts.debug) console.log("DELETE", id);
      if (destroy) destroy({
        variables: {
          input: {
            id: id || options.id
          }
        },
        onCompleted: function onCompleted(data) {
          if (flashMessages) handleNotifications(data);
          if (options !== null && options !== void 0 && options.onCompleted) options.onCompleted(data);
        }
      });
    };
    var onImport = function onImport(file, options) {
      if (importMutationDispatcher) importMutationDispatcher({
        context: {
          hasUpload: true
        },
        variables: {
          input: {
            file: file
          }
        },
        onCompleted: function onCompleted(data) {
          if (flashMessages) handleNotifications(data);
          if (options !== null && options !== void 0 && options.onCompleted) options.onCompleted(data);
        }
      });
    };
    return {
      onSave: onSave,
      onDelete: onDelete,
      onImport: onImport,
      refetch: refetch,
      record: record,
      loading: loading,
      submitting: creating || updating,
      errors: errors
    };
  };
}
export default useGraphqlModel;